<template>
    <ul class="slm-history-map__list" :class="listView">
        <template v-if="histories && histories.length > 0">
            <history-component v-for="history in histories" :key="history.url" :history="history"/>
        </template>
        <li v-else class="slm-history-map__destination slm-history-map__destination--no-result">
            <div class="slm-history-map__destination--no-result-content">
                <h3 class="slm-history-map__destination--title">
                    Inget resultat
                </h3>
                <p class="slm-history-map__destination--description">
                    Med det filter du valt hittar vi inget material
                </p>
            </div>
        </li>
    </ul>
</template>

<script>
import historyComponent from './history.vue'
export default {
    name: 'list-component',
    props: ['histories'],
    computed: {
        listView() {
            return this.$store.state.listView;
        },
    },
    components: { 
        historyComponent 
    },
}
</script>